export default __webpack_public_path__ + "static/media/arti.f63766fe.png";